export default {
  companyUrl: 'https://stage-www.lwtears.com',
  pliUrl: 'https://stage-pli.lwtears.com',
  digitalProductSupportUrl: 'https://stage-www.lwtears.com/contact-us/digital-product-support',
  digitalAssetsUrl: 'https://a-z-educator-content-stage.lwtears.com',
};
